export default {
  name: 'vehicleInductedMember',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction.methodRequest(
      `/register/vehicle/induction/${data.vehicleid}/operator`,
      'POST',
      data
    )
  },
}
